import React from 'react';
import { Button, ButtonProps } from 'evergreen-ui';
import { NavLink } from 'react-router-dom';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  'navlink-active': {
    color: 'rgb(16, 112, 202)',
    backgroundColor: 'rgba(16, 112, 202, 0.09) !important',
  },
});
interface NavLinkButton extends ButtonProps {
  to: string,
}
export const NavLinkButton = React.memo(({
  to,
  children,
  ...btnProps
}: NavLinkButton) => {
  const classes = useStyles();

  return (
  /*  @ts-ignore */
    <Button
      appearance="minimal"
      {...btnProps}
      activeClassName={classes['navlink-active']}
      is={NavLink}
      to={to}
    >
      {children}
    </Button>
  );
});

NavLinkButton.displayName = 'NavLinkButton';
